/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeResponseAllOfData
 */
export interface MeResponseAllOfData {
    /**
     * 名前
     * @type {string}
     * @memberof MeResponseAllOfData
     */
    firstName: string;
    /**
     * 苗字
     * @type {string}
     * @memberof MeResponseAllOfData
     */
    lastName: string;
    /**
     * メールアドレス(user_id)
     * @type {string}
     * @memberof MeResponseAllOfData
     */
    email: string;
}

export function MeResponseAllOfDataFromJSON(json: any): MeResponseAllOfData {
    return MeResponseAllOfDataFromJSONTyped(json, false);
}

export function MeResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
    };
}

export function MeResponseAllOfDataToJSON(value?: MeResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
    };
}

